import { useEffect, useRef } from "react";

import type { CheckoutSession, CheckoutStatus, AppContext } from "@/types";
import {
  shouldPoll,
  pollPaymentStatus,
} from "../services/payment-polling-service";

export function usePaymentPolling(
  session: CheckoutSession | undefined,
  ctxRef: React.MutableRefObject<AppContext | null>,
  onSessionFetched: (session: CheckoutSession) => void,
): void {
  const isPollingRef = useRef<boolean>(false);
  const pollingStatusRef = useRef<CheckoutStatus | null>(null);

  useEffect(() => {
    if (!session || !shouldPoll(session)) {
      if (isPollingRef.current) {
        isPollingRef.current = false;
        pollingStatusRef.current = null;
      }
      return;
    }

    if (
      isPollingRef.current &&
      pollingStatusRef.current === session.status
    ) {
      return;
    }

    if (ctxRef.current?.getCheckoutSession && ctxRef.current?.store) {
      isPollingRef.current = true;
      pollingStatusRef.current = session.status;

      pollPaymentStatus(
        ctxRef.current.store,
        ctxRef.current.getCheckoutSession,
        onSessionFetched,
        session.status,
      ).catch(() => {
        if (pollingStatusRef.current === session.status) {
          isPollingRef.current = false;
          pollingStatusRef.current = null;
        }
      });
    }
  }, [session?.status, onSessionFetched, session, ctxRef]);
}
